import ModelMarshaller from './ModelMarshaller';
import PriceItem from './PriceItem';

export default class PriceItemMashaller extends ModelMarshaller<PriceItem> {

   

    toJSON() {
        if (this.data instanceof PriceItem) {
            let json :any = {}
            json[this.data.$name] = this.data.$price;
            return json
        }
        return this.data
    
    }
    
    toModel(): PriceItem {
        if (this.data instanceof PriceItem) {
            return this.data
        }
        
        let size = Object.getOwnPropertyNames(this.data)[0]
        console.log(this.data)
        console.log(size)
        console.log(this.data[size])
        return new PriceItem(size,this.data[size])
    }


}